export const metrics = {
  CONVERSION_RATE: 1,
  RECEIPT_COUNT: 2,
  SALE_COUNT: 3,
  ENDORSEMENT: 4,
  ENDORSEMENT_PER_M2: 5,
  VISITOR_COUNT: 6,
  ENTRANCE_RATE: 7,
  DENSITY: 8,
  INTEREST_RATIO: 9,
  TIME: 10,
  SINGULAR_VISITOR_COUNT: 61,
  GROUP_OF_TWO_VISITOR_COUNT: 62,
  GROUP_OF_THREE_VISITOR_COUNT: 63,
  GROUP_OF_FOUR_VISITOR_COUNT: 64
};

export const metricOptions = [
  { value: metrics.VISITOR_COUNT, label: 'VISITOR_COUNT' },
  { value: metrics.ENDORSEMENT, label: 'ENDORSEMENT' },
  { value: metrics.CONVERSION_RATE, label: 'CONVERSION_RATE' },
  { value: metrics.RECEIPT_COUNT, label: 'RECEIPT_COUNT' },
  { value: metrics.SALE_COUNT, label: 'SALE_COUNT' },
  { value: metrics.ENDORSEMENT_PER_M2, label: 'ENDORSEMENT_PER_M2' },
  { value: metrics.ENTRANCE_RATE, label: 'ENTRANCE_RATE' }
];
